export default "__VITE_ASSET__B4_$BQjX__"